var map = {
	"./contact/createInitialSchema": 997,
	"./cpo/createInitialSchema": 998,
	"./customer/createInitialSchema": 999,
	"./forwarderPo/createInitialSchema": 1000,
	"./incomingInvoice/createInitialSchema": 1001,
	"./incomingPayment/createInitialSchema": 1002,
	"./outgoingInvoice/createInitialSchema": 1003,
	"./outgoingPayment/createInitialSchema": 1004,
	"./outgoingQuote/createInitialSchema": 1005,
	"./product/createInitialSchema": 1006,
	"./receiving/createInitialSchema": 1007,
	"./shipping/createInitialSchema": 1008,
	"./spo/createInitialSchema": 1009,
	"./spoSched/createInitialSchema": 1010,
	"./vatDeductRecord/createInitialSchema": 1011,
	"./vendor/createInitialSchema": 1012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 996;